/**
 * Extracts the job result tracking key (jrtk) from a viewjob URL and enriches it
 * with the AdBlob (ad) or BlobKey (xkcb) if present. This ensures correct sponsorship
 * attribution when the JRTK is sent as jobResultTrackingKey in the federated GraphQL query.
 */
export function enrichJobResultTrackingKey(url: string): string | undefined {
    try {
        const { searchParams } = new URL(url);
        const jrtk = searchParams.get('jrtk');
        if (!jrtk) return undefined;
        if (jrtk.includes('--')) return jrtk;

        const blob = searchParams.get('ad') ?? searchParams.get('xkcb');
        return blob ? `${jrtk}--${blob}` : jrtk;
    } catch {
        return undefined;
    }
}
